import { rgba } from 'polished';
import { PopupMenuButton } from 'shared/components/ui/popup-menu';
import styled, { css } from 'styled-components';

// Focus stays in the input; the arrow-key active row is a virtual selection, not a focus ring.
export const SuggestionButton = styled(PopupMenuButton)<{ $isActive: boolean }>`
  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      background: ${rgba(theme.palette.text.primary, 0.06)};
    `};
`;
